import { customElement } from "lit/decorators.js";
import ColorHash from "color-hash";
import { SlhNavigationAvatar } from "@slhuinav/avatar";

/**
 * @customElement slh-nav-organization-avatar
 *
 * @cssprop --slh-color-neutral-shade-00 - Avatar font color.
 * @cssprop --slh-default-font-family - Avatar font family.
 * @cssprop --slh-base-xs-font-size - Avatar font size.
 * @cssprop --slh-base-bold-font-weight - Avatar font weight.
 * @cssprop --slh-color-neutral-shade-40 - Avatar icon color.
 * @cssprop --slh-color-outline - Avatar focus visible outline color.
 */
@customElement("slh-nav-organization-avatar")
export default class SlhNavigationOrganizationAvatar extends SlhNavigationAvatar {
  /**
   * @returns color hex value of user full name generated by color-hash library
   */
  getFullNameColor(): string {
    const colorHash = new ColorHash();
    let fullNameColor = "";
    const fullName = this.user?.fullName.trim();
    if (fullName) {
      fullNameColor = colorHash.hex(fullName);
    }
    return fullNameColor;
  }
}
